// extracted by mini-css-extract-plugin
export default {"item":"Summary_item__Lfnbl","wrapper":"Summary_wrapper__Jw1GU"};